import React from 'react';

import styles from './SettingsModalBody.module.scss';

export const SettingsModalBody: React.FC<React.PropsWithChildren> = ({
    children,
}) => <div className={styles.main}>{children}</div>;
